import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { MenuList } from './interfaces';
import { AuthService } from '@core/services';
import { RolModuleEnum } from '@core/enums';

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit {
  model: MenuList[] = [];

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.model = [
      {
        label: '',
        icon: 'home',
        items: [
          // {
          //   label: 'Dashboard',
          //   icon: 'dashboard',
          //   routerLink: ['/'],
          // },
          {
            label: 'Account',
            icon: 'account_balance',
            visible: this.authService.hasRole(RolModuleEnum.Account),
            routerLink: ['/account'],
          },
          {
            label: 'Resellers',
            icon: 'group',
            visible: this.authService.hasRole(RolModuleEnum.Reseller),
            routerLink: ['/reseller'],
          },
          {
            label: 'Store',
            icon: 'store',
            visible: this.authService.hasRole(RolModuleEnum.Store),
            routerLink: ['/store'],
          },
          {
            label: 'Role',
            icon: 'list_alt',
            visible: this.authService.hasRole(RolModuleEnum.Role),
            routerLink: ['/role'],
          },
          {
            label: 'User',
            icon: 'person',
            visible: this.authService.hasRole(RolModuleEnum.User),
            routerLink: ['/user'],
          },
          {
            label: 'Apk',
            icon: 'android',
            visible: this.authService.hasRole(RolModuleEnum.Apk),
            routerLink: ['/apk'],
          },
        ],
      },
    ];
  }
}
